import { Card, Col, Row } from 'antd';
import {
  AlertOutlined, DollarOutlined, PrinterOutlined, TeamOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router';
import type { DashboardSummary } from '@/api/dashboard';
import { DashboardHeader, KpiGrid, PKR, type KpiSpec } from './shared';

/**
 * Cashier dashboard — only what's needed to take money in. Today's collection,
 * how many defaulters, and a big-button list to start a payment or look up a
 * student. No expense / ledger / academic clutter.
 */
export function CashierDashboard({ data }: { data: DashboardSummary }) {
  const kpis: KpiSpec[] = [
    {
      key: 'fees-today',
      label: "Today's collection",
      value: PKR(Number(data.fees.collectedToday)),
      hint: 'Money you and the team took in today',
      sensitive: true,
      icon: <DollarOutlined />,
      tone: 'success',
    },
    {
      key: 'fees-month',
      label: 'Month-to-date',
      value: PKR(Number(data.fees.collectedThisMonth)),
      hint: 'Running total since the 1st',
      sensitive: true,
      icon: <DollarOutlined />,
      tone: 'info',
    },
    {
      key: 'defaulters',
      label: 'Defaulters',
      value: data.fees.defaulterCount.toLocaleString(),
      hint: 'Students with unpaid months — call them in',
      icon: <AlertOutlined />,
      tone: 'warning',
    },
  ];

  return (
    <div style={{ display: 'grid', gap: 20 }}>
      <DashboardHeader role={data.role} asOf={data.asOf} title="Cash desk" />
      <KpiGrid kpis={kpis} />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card title="Take a payment" size="small">
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2 }}>
              <li><Link to="/fee/collect">Collect from a student</Link></li>
              <li><Link to="/students">Look up a student</Link></li>
              <li><Link to="/fee/defaulters">Today's defaulter list</Link></li>
            </ul>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title="End of day" size="small">
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2 }}>
              <li><Link to="/fee/vouchers"><PrinterOutlined /> Print pending vouchers</Link></li>
              <li><Link to="/reports/fee-collection"><TeamOutlined /> Daily collection report</Link></li>
            </ul>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
